import { PayloadAction } from '@reduxjs/toolkit';

import { ExtraReducerBuilder } from '../../types/shared';
import { WritableQuoteBuilderStateType } from '../../types/state';
import { deleteSnapQuoteLineAttachment } from '../endpoints/delete-snap-quote-line-attachment';
import { getQuoteLineOrThrow } from '../utilities/action-guards';

function deleteSnapQuoteLineAttachmentFulfilled(
  state: WritableQuoteBuilderStateType,
  action: PayloadAction<typeof deleteSnapQuoteLineAttachment.Types.ResultType>,
) {
  const { snapQuoteLineUuid } = action.payload;

  const snapQuoteLine = getQuoteLineOrThrow(state, snapQuoteLineUuid);

  snapQuoteLine.documentIds = snapQuoteLine.documentIds.filter(
    (id) => id !== action.payload.id,
  );
  delete snapQuoteLine.documents[action.payload.id];
}

export function deleteSnapQuoteLineAttachmentReducer(
  builder: ExtraReducerBuilder,
) {
  builder.addMatcher(
    deleteSnapQuoteLineAttachment.matchFulfilled,
    deleteSnapQuoteLineAttachmentFulfilled,
  );
}
